import dayjs from "dayjs"

export const clearFilterData = {
  DrvId: null,
  PayTmSt: dayjs().startOf('month').format("YYYY-MM-DD"),
  PayTmEn: dayjs().endOf('month').format("YYYY-MM-DD"),
}

export const initFilterData = {
  ...clearFilterData
}

export const initAddData = {
  DrvId: null,
  Amnt: "",
  Dscp: "",
}
